module.exports = __webpack_public_path__ + "img/store_TikTok.113bb82d.svg";